export default __webpack_public_path__ + "static/media/Parallax-HUD-Label.427beafe.jpg";